<template>
  <v-dialog v-model="showModal">
    <v-card
      elevation="0"
      color="#E2E2E2"
      class="pa-2"
    >
      <v-card
        elevation="0"
        color="#E2E2E2"
      >
        <v-card-title>
          <p class="process-header">
            Current Issue Status
          </p>
        </v-card-title>
        <v-card-text class="justify-center">
          <v-form
            ref="form"
            v-model="valid"
          >
            <div class="checkout-details">
              <v-radio-group
                v-model="issueStatus"
                row
                class="field-text-style"
                light
                :rules="[(v) => !!v || 'This field is required']"
                @change="isIssueStatusChanged"
              >
                <v-radio
                  label="Pending"
                  value="pending"
                  light
                  color="#FF3700"
                >
                  <template #label>
                    <span class="input__label">Pending</span>
                  </template>
                </v-radio>
                <v-radio
                  label="Completed"
                  value="completed"
                  light
                  color="#FF3700"
                >
                  <template #label>
                    <span class="input__label">Completed</span>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-textarea
                v-if="showReasonField"
                ref="status"
                v-model="pendingReason"
                dense
                :rules="issueStatus === 'pending' ? [(v) => !!v || 'This field is required'] : []"
                filled
                class="field-text-style"
                hint="Only required if Issue Status is 'Pending'."
                persistent-hint
                color="#000000"
                light
                outlined
                label="Reason*"
              />
              <v-textarea
                v-if="showRootCauseField"
                ref="status"
                v-model="rootCause"
                dense
                :rules="issueStatus === 'completed' ? [(v) => !!v || 'This field is required'] : []"
                filled
                class="field-text-style"
                hint="Only required if Issue Status is 'Completed'."
                persistent-hint
                color="#000000"
                light
                outlined
                label="Root Cause of Issue*"
              />
            </div>
          </v-form>
        </v-card-text>
      </v-card>
      <v-btn
        color="#37474F"
        class="mt-5 btn-style"
        elevation="0"
        @click="issueStatusGathered()"
      >
        Cost Shift
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="showModal = false"
      >
        Cancel
      </v-btn>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-dialog>
</template>

  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';
  import moment from 'moment';

  export default {
    name: 'GatherIssueStatus',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      activeCheckInDetails: {
        type: Object,
      },
    },
    data: () => ({
      loading: false,
      valid: false,
      issueStatus: null,
      pendingReason: null,
      rootCause: null,
      showReasonField: false,
      showRootCauseField: false,
      showModal: true,
    }),
    methods: {
      issueStatusGathered () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        this.$store.dispatch('swiftuser/saveIssueStatus', {
          status: this.issueStatus,
          pendingReason: this.pendingReason,
          rootCause: this.rootCause,
        });
        setTimeout(() => {
          this.loading = false;
          this.$emit('issue-status-stored');
        }, 1000);
        this.Currentcheckout();
      },
      Currentcheckout () {
        this.$store.dispatch('swiftuser/checkOutUser', {
          checkOutTime: {
            checkout_time: moment.utc().format(),
            type: 'cost-shift',
            manual_checkout_reason: null,
            checkout_gate: null,
            latitude: null,
            longitude: null,
          },
          checkInId: this.activeCheckInDetails.id,
        }).then(response => {
          this.loading = false;
          this.$emit('cost-shift');
          this.$emit('checkout-completed');
        }).catch(errors => {
          this.loading = false;
        });
      },
      costShift () {
          this.loading = true;
          const siteId = this.$route.params.siteId;
          this.$store.dispatch('swiftuser/checkInUser', {
            orgExtId: this.activeCheckInDetails.organization_id,
          details: {
            checkin_time: moment.utc().format(),
            location_id: siteId,
            type: 'worker',
            checkin_method_type: 'cost-shift',
            project_id: this.selectedWorkDetails.details.project.id,
          },
          }).then(response => {
            this.completeCheckInProcess();
          }).catch(errors => {
            this.loading = false;
          });
        },
      isIssueStatusChanged () {
        if (this.issueStatus === 'completed') {
          this.pendingReason = null;
          this.showReasonField = false;
          this.showRootCauseField = true;
        } else {
          this.rootCause = null;
          this.showRootCauseField = false;
          this.showReasonField = true;
        }
      },
      cancel () {
          this.loading = true;
          localStorage.removeItem('siteId');
          localStorage.removeItem('scannedTime');
          setTimeout(() => {
            this.$router.push({ name: 'CheckOut' });
          }, 1000);
      },
    },
  };
  </script>
